import { httpClient, ApiResponse } from '@/utils';
import {
  staticGeneralFaqEndpoints,
  getGeneralFaqEndpoints,
  ICreateGeneralFaqDTO,
  ICreateGeneralFaqResponse,
  IDeleteGeneralFaqsDTO,
  IUpdateGeneralFaqDTO,
  IGetGeneralFaqsDTO,
  IGetGeneralFaqsResponse,
} from '@/models/generalFaq.model';

class GeneralFaqAPI {
  static getGeneralFaqs(params: IGetGeneralFaqsDTO): ApiResponse<IGetGeneralFaqsResponse> {
    const { GET_GENERAL_FAQS } = staticGeneralFaqEndpoints;
    return httpClient.get<IGetGeneralFaqsResponse>(GET_GENERAL_FAQS, {
      params,
    });
  }

  static createGeneralFaq(data: ICreateGeneralFaqDTO): ApiResponse<ICreateGeneralFaqResponse> {
    const { CREATE_GENERAL_FAQ } = staticGeneralFaqEndpoints;
    return httpClient.post<ICreateGeneralFaqResponse>(CREATE_GENERAL_FAQ, data);
  }

  static updateGeneralFaq({ faqId, ...data }: IUpdateGeneralFaqDTO): ApiResponse<ICreateGeneralFaqResponse> {
    const { UPDATE_GENERAL_FAQ } = getGeneralFaqEndpoints({ faqId });
    return httpClient.patch<ICreateGeneralFaqResponse>(UPDATE_GENERAL_FAQ, data);
  }

  static deleteGeneralFaqs(data: IDeleteGeneralFaqsDTO): ApiResponse<void> {
    const { DELETE_GENERAL_FAQS } = staticGeneralFaqEndpoints;
    return httpClient.delete<void>(DELETE_GENERAL_FAQS, { data });
  }
}

export default GeneralFaqAPI;
